import { StyleSheet } from 'react-native';

import maxContainerWidthStyle from '../../../styles/max-container-width/max-container-width.style';

export default StyleSheet.create({
  container: {
    flex: 1,
    ...maxContainerWidthStyle,
  },
  section: {
    flex: 1,
    padding: 15,
  },
  checkSection: {
    paddingHorizontal: 15,
    paddingBottom: 15,
  },
  instructions: {
    marginBottom: 15,
  },
});
